<script>
	import Leader from '$lib/icons/leadership-svgrepo-com.svelte';
	import Fence from '$lib/icons/fence-for-horses-jumps-svgrepo-com.svelte';
</script>

<div class="content-div">
	<span class="chip static-courser bg-[#D17208] mt-4 text-white"><b>Case Study 3</b></span>
	<div class="flex">
		<h1 class="content-heading">Transboundary conservation</h1>
		<Fence />
	</div>

	<div class="flex pt-2 pb-4">
		<Leader />
		<div class="pl-4 text-lg">
			<a class="anchor" href="/team#tjeremy_perkins">Jeremy Perkins</a>
		</div>
	</div>

	<blockquote class="content-blockquote">
		This task will establish the biodiversity data foundation that is needed to assess the
		vulnerability of existing mammalian species populations to climate change and the key
		conservation measures that are necessary to avoid the widespread collapse of key species
		populations and consequent biodiversity losses. African mammals adapted to past episodes of
		climate change by moving between eastern and southern Africa along has been termed the ‘drought
		corridor’. In pluvial periods the equatorial rainforest expanded to block the drought corridor,
		but in dry periods movements along it are key to understanding not only the current distribution
		of eastern and southern African mammals, but also how they were able to adapt to climate change.
		The severity of climate change in southern Africa is projected to be such that even large
		existing trans frontier conservation areas (TFCAs) such as the Kavango-Zambezi (KAZA-TFCA) may
		not encompass the required rainfall gradient for the African mega fauna to survive. Land
		use/land cover change mapping will be used to identify the key areas where wildlife migratory
		corridors along the drought corridor are today blocked by human activities such as agriculture.
		The results from the mapping of available surface water along the drought corridor will be used
		to identify areas of existing and future conflict between water dependent wildlife and people,
		and the extent to which available groundwater resources can be used to compensate for
		increasingly restricted access to surficial water in the future. Mapping will assess the extent
		to which existing Community Based National Resource Management and other wildlife and wilderness
		based tourism initiatives can be expanded within the drought corridor to ensure its viability in
		the face of declining outputs from traditional agriculture in Southern Africa. Biodiversity
		tipping points along the drought corridor will be established from the regional climate analysis
		and used alongside those for traditional agriculture to establish the key spatial areas and
		points in time at which such key adaptive strategies such as corridors that link conservation
		areas between eastern and southern Africa, to form a new TFCA such as the Kalahari-Rift Valley
		(KALARIVA) (Perkins, 2019) must be in place.
	</blockquote>
</div>
